export default {
    validator(type, value, regExpression) {
        let regExpStr = null;
        switch (type) {
            case 0: // 手机
                //regExpStr = /^((13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])+\d{8})$/;
                regExpStr = /^1\d{10}$/;
                break;
            case 1: // 电话
                regExpStr = /^(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14}$/;
                break;
            case 2: // 身份证
                regExpStr = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/;
                break;
            case 3: // 邮箱
                regExpStr = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/;
                break;
            case 4: // 网址
                /* eslint-disable */
                regExpStr = /(http|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/i;
                break;
            case 99: // 自定义正则表达式
                regExpStr = regExpression;
                break;
        }
        const regExp = new RegExp(regExpStr);
        return regExp.test(value);
    },
};
